import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pricebookItems: [{}],
  pricebookItem: {},
  newPricebookItem: {},
  updatedPricebookItem: {},
  deletedPricebookItem: {},
  error: null,
};

const priceBookSlice = createSlice({
  name: 'priceBook',
  initialState,
  reducers: {
    setReducerError: (state, action) => {
      state.error = action.error;
    },
    setPricebookItems: (state, action) => {
      state.pricebookItems = action.payload;
      state.error = null;
    },
    setPricebookItem: (state, action) => {
      state.pricebookItem = action.payload;
      state.error = null;
    },
    setNewPricebookItem: (state, action) => {
      state.newPricebookItem = action.payload;
      state.error = null;
    },
    setUpdatedPricebookItem: (state, action) => {
      state.updatedPricebookItem = action.payload;
      state.error = null;
    },
    setDeletedPricebookItem: (state, action) => {
      state.deletedPricebookItem = action.payload;
      state.error = null;
    },
    setResetPriceBook: () => {
      return initialState;
    },
  },
});

export const {
  setReducerError,
  setPricebookItems,
  setPricebookItem,
  setNewPricebookItem,
  setUpdatedPricebookItem,
  setDeletedPricebookItem,
  setResetPriceBook,
} = priceBookSlice.actions;

export default priceBookSlice.reducer;
